import React, { useContext, useMemo } from "react";
import { type Moment } from 'moment';
import { Context } from '../AccelProvider/AccelProvider';
import type { DateTimeFormat } from '../../utils/converters/DateTimeConverter';
import { DateTimeConverter } from '../../utils/converters/DateTimeConverter';

type DateTimeProps = {
    date: Date | Moment,
    /**
     * LT  1:30 PM
     *
     * LTS 1:30:05 PM
     *
     * L 11/25/2021
     *
     * l    11/25/2021
     *
     * LL    November 25, 2021
     *
     * ll    Nov 25, 2021
     *
     * LLL   November 25, 2021 1:30 PM
     *
     * lll   Nov 25, 2021 1:30 PM
     *
     * LLLL  Thursday, November 25, 2021 1:30 PM
     *
     * llll  Thu, Nov 25, 2021 1:30 PM
     */
    format?: DateTimeFormat;
    customFormat?: string;
    fromNow?: boolean;
    className?: string;
}

const DateTime: React.FC<DateTimeProps> = (props) => {
    const { lang } = useContext(Context);

    const date = useMemo(() => {
        if (props.fromNow === true) return DateTimeConverter.fromNow(props.date, lang);
        return DateTimeConverter.format(props.date, lang, props.format ?? props.customFormat);
    }, [props.date, props.format, props.customFormat, props.fromNow, lang]);

    const title = useMemo(() => DateTimeConverter.format(props.date, lang), [props.date, lang]);

    return <span className={props.className} title={title}>{date}</span>;
}
export default DateTime;